import { Icon, Text } from '@oneaudi/unified-web-components';
import { SliderCatalogueHeadlineProps } from '~/components/slider-panel/components/slider-catalogue-headline/models/slider-catalogue-headline-props';
import {
	SliderCatalogueCloser,
	SliderCatalogueHeadlineStyle,
	SliderCatalogueSectionHeadlineStyle,
} from '~/components/slider-panel/components/slider-catalogue-headline/styles/slider-catalogue-headline-style';

export function SliderCatalogueHeadline({
	headline,
	isVisible,
	spaceBetween,
	collapsCatalogue,
}: SliderCatalogueHeadlineProps) {
	return (
		<SliderCatalogueHeadlineStyle
			spaceBetween={spaceBetween}
			className={`slider-catalogue-headline ${isVisible && 'visible'}`}>
			<SliderCatalogueSectionHeadlineStyle className="slider-catalogue-section-headline">
				<Text variant={{ type: 'copy', order: '2', style: 'normal' }}>{headline}</Text>
			</SliderCatalogueSectionHeadlineStyle>
			<SliderCatalogueCloser onClick={() => collapsCatalogue()} className="slider-catalogue-closer">
				<Icon name="cancel" size={'s'} className="asLink" />
			</SliderCatalogueCloser>
		</SliderCatalogueHeadlineStyle>
	);
}
